const tool = {
	// 截取连接地址
	getUrlParam: function(name) { // 获取url参数值
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
		//构造一个含有目标参数的正则表达式对象
		var index = window.location.href.split("?")
		var str = '';
		if (str.length !== 2) {
			str = index[index.length - 1]
		} else {
			str = index[1]
		}
		if (str) {
			var r = str.substr(0).match(reg);
			//匹配目标参数
			if (r != null)
				return decodeURI(r[2]);
			return '';
		} else {
			return ''
		}
	},

	//将时间戳转换成标准日期格式
	/*
	 *timestamp时间戳
	 *time 是否显示时间true false
	 */
	formatTime: function(timestamp, time) {
		var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
		var Y = date.getFullYear() + '-';
		var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
		var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';
		var h = date.getHours() + ':';
		var m = date.getMinutes() + ':';
		var s = date.getSeconds();
		if (time) {
			return Y + M + D + h + m + s;
		} else {
			return Y + M + D;
		}

	},
	//带天数的时间转换
	/*
	 *   ''  显示天 1，不显示天 2，不显示天和小时
	 */
	countDown: function(times, t = '') {
		var day = 0,
			hour = 0,
			minute = 0,
			second = 0; //时间默认值
		if (times > 0) {
			day = Math.floor(times / (60 * 60 * 24 * 1000));
			hour = Math.floor(times / (60 * 60 * 1000)) - (day * 24);
			minute = Math.floor(times / 60) - (day * 24 * 60 * 1000) - (hour * 60);
			second = Math.floor(times) - (day * 24 * 60 * 60 * 1000) - (hour * 60 * 60) - (minute * 60);
		}
		if (day <= 9) day = day;
		if (hour <= 9) hour = '0' + hour;
		if (minute <= 9) minute = '0' + minute;
		if (second <= 9) second = '0' + second;
		//显示
		let txt;
		if (t == '') {
			txt = `${day}天${hour}：${minute}：${second}`
		} else if (t == 1) {
			txt = `${hour}：${minute}：${second}`
		} else if (t == 2) {
			txt = `${minute}：${second}`
		} else if (t == 3) {
			txt = `${day}天${hour}小时`
		}

		return txt;
	},
	//时间转换
	timeago: function(value) {
		var minute = 1000 * 60;
		var hour = minute * 60;
		var day = hour * 24;
		var halfamonth = day * 15;
		var month = day * 30;
		var now = new Date().getTime();
		var diffValue = now - value;
		if (diffValue < 0) {
			return;
		}
		var monthC = diffValue / month;
		var weekC = diffValue / (7 * day);
		var dayC = diffValue / day;
		var hourC = diffValue / hour;
		var minC = diffValue / minute;
		var result = ""
		if (monthC >= 1) {
			result = "" + parseInt(monthC) + "月前";
		} else if (weekC >= 1) {
			result = "" + parseInt(weekC) + "周前";
		} else if (dayC >= 1) {
			result = "" + parseInt(dayC) + "天前";
		} else if (hourC >= 1) {
			result = "" + parseInt(hourC) + "小时前";
		} else if (minC >= 1) {
			result = "" + parseInt(minC) + "分钟前";
		} else
			result = "刚刚";
		return result;
	},

	//或取几天前的时间
	getDateStr: function(AddDayCount) {
		var dd = new Date();
		dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
		var y = dd.getFullYear();
		var m = (dd.getMonth() + 1) < 10 ? "0" + (dd.getMonth() + 1) : (dd.getMonth() + 1); //获取当前月份的日期，不足10补0
		var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
		return y + "-" + m + "-" + d;
	},
	//得到星期几
	getWeek: function(day) {
		var weekDay = ["星期天", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
		var myDate = new Date(Date.parse(day));
		let week = weekDay[myDate.getDay()]
		return week;
	},

	//验证
  // 验证手机号
	validatePassword: function(name) {
    var myreg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/;

		// var myreg =
		// 	/^(((14[0-9]{1})|(16[0-9]{1})|(13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(19[0-9]{1})|(17[0-9]{1}))+\d{8})$/;
		if (!myreg.test(name)) {
			return false;
		}
		return true;
	},
	// 验证手机号
	validateMobile: function(name) {
		var myreg =
			/^(((14[0-9]{1})|(16[0-9]{1})|(13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(19[0-9]{1})|(17[0-9]{1}))+\d{8})$/;
		if (!myreg.test(name)) {
			return false;
		}
		return true;
	},
	// 验证台湾手机号
	validateFormosaMobile: function(name) {
		// var myreg = /^(886)?09\d{8}$/;// 校验港澳台手机号;
		var myreg = /^(886)?09\d{8}$/;
		if (!myreg.test(name)) {
			return false;
		}
		return true;
	},
	// 验证越南手机号
	validateVietnameseMobile: function(name) {
		var myreg = /^(\\+?84|0)?((1(2([0-9])|6([2-9])|88|99))|(9((?!5)[0-9])))([0-9]{7})$/;
		if (!myreg.test(name)) {
			return false;
		}
		return true;
	},
	// 验证日本手机号
	validateJapanMobile: function(name) {
		var myreg = /^(\+?81|0)\d{1,4}[ \-]?\d{1,4}[ \-]?\d{4}$/;
		if (!myreg.test(name)) {
			return false;
		}
		return true;
	},
	// 验证韩国手机号
	validateKoreaMobile: function(name) {
		var myreg = /^(00)?82\-?0[71](?:\d{8,9})$/;
		if (!myreg.test(name)) {
			return false;
		}
		return true;
	},
	// 验证马来西亚手机号
	validateMalaysiaMobile: function(name) {
		// var myreg = /^(\\+?6?01){1}(([145]{1}(\\-|\\s)?\\d{7,8})|([236789]{1}(\\s|\\-)?\\d{7}))$/;
		var myreg = /^(00){0,1}(60){1}1\d{8,9}$/
		if (!myreg.test(name)) {
			return false;
		}
		return true;
	},
	// 验证邮箱
	validateEmail: function(name) {
		var myreg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
		if (!myreg.test(name)) {
			return false;
		}
		return true;
	},
	// 验证是否为空
	validateEmpty: function(obj) {
		if (typeof obj == "undefined" || obj == null || obj == "") {
			return true;
		} else {
			return false;
		}
	},
	checkInviteCode: function(nubmer) {
		var re = /^[0-9a-zA-Z]*$/; //判断字符串是否为数字和字母组合
		if (!re.test(nubmer) || nubmer.length < 4) {
			return false;
		} else {
			return true;
		}
	},
	validatePasswd: function(name) { //(?=.*[^a-zA-Z0-9])
		var pwdRegex = new RegExp('(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]).{8,16}');
		if (!pwdRegex.test(name)) {
			return false;
		}
		return true;
	},
	validateTransactionPasswd: function(name) { //
		var pwdRegex = new RegExp('^\[0-9]{6}$');
		if (!pwdRegex.test(name)) {
			return false;
		}
		return true;
	},
	validateRewardAmount: function(num) {
		var pwdRegex = new RegExp('^([1-9]|10)$');
		if (!pwdRegex.test(num)) {
			return false;
		}
		return true;
	},

	formatStarString: function(name, keepNum) {
		var breakNum = 1;
		if (!keepNum) {
			keepNum = 2;
		}
		breakNum = keepNum / 2;
		let newStr;
		if (name.length === keepNum) {
			newStr = name.substr(0, breakNum) + '*';
		} else if (name.length > keepNum) {
			let char = '';
			for (let i = 0, len = name.length - keepNum; i < len; i++) {
				char += '*';
			}
			newStr = name.substr(0, breakNum) + char + name.substr(-1 * breakNum, breakNum);
		} else {
			newStr = name;
		}

		return newStr;
	},
	validateNum: function(num) {

		var reg = /^[0-9]+.?[0-9]*$/; //判断字符串是否为数字 ，判断正整数用/^[1-9]+[0-9]*]*$/

		if (!reg.test(num)) {

			return false;

		}
		return true;

	},
}
export default tool
